import {
  init,
  browserTracingIntegration,
  browserProfilingIntegration,
} from "@sentry/react";

const TEST_HOST = "kassa-test.appsmen.nl";

export const initSentry = () => {
  const isTestEnvironment = window.location.hostname === TEST_HOST;
  init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [browserTracingIntegration(), browserProfilingIntegration()],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    environment: import.meta.env.MODE,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/api-tst.appsmen.nl/,
      /^https:\/\/api.appsmen.nl/,
    ],
    profileLifecycle: "trace",
    enabled: import.meta.env.MODE === "production" && !isTestEnvironment,
  });
};
